import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useQuery, useMutation, gql } from '@apollo/client'
import Template from '../../../components/Template'
import CentredLoader from '../../../components/CentredLoader'
import { FICHE_COMPARATIVE_FRAGMENT } from '../../../Fragments'
import {
  openValidationPopup,
  openErrorPopup,
} from '../../../components/ConfirmationPopups'
import { FicheComparativeType } from '../../../types/index'
import FicheForm from '../components/FicheForm'
import { button } from '../../../styles/button'

const FICHE_COMPARATIVE_SHOW = gql`
  query getFicheComparative($id: Int!) {
    ficheComparative(id: $id) {
      ...FicheComparativeFragment
    }
  }
  ${FICHE_COMPARATIVE_FRAGMENT}
`

const FICHE_COMPARATIVE_UPDATE = gql`
  mutation updateFicheComparative(
    $id: Int!
    $countryConfigId: Int!
    $metaTitle: String!
    $metaDescription: String
    $comparativeChart: FicheComponentInput
    $customerReviews: FicheComponentInput
    $mainTitle: FicheComponentInput
    $illustratedTexts: FicheComponentInput
    $nextStep: FicheComponentInput
  ) {
    updateFicheComparative(
      id: $id
      countryConfigId: $countryConfigId
      metaTitle: $metaTitle
      metaDescription: $metaDescription
      comparativeChart: $comparativeChart
      customerReviews: $customerReviews
      mainTitle: $mainTitle
      illustratedTexts: $illustratedTexts
      nextStep: $nextStep
    ) {
      ficheComparative {
        id
      }
    }
  }
`

interface FicheComparativeData {
  ficheComparative: FicheComparativeType
}

interface FicheComparativeVars {
  id: number
}

interface Props {
  ficheComparativeId: number
}

const Edit = (props: Props): JSX.Element => {
  return (
    <Template>
      <FicheComparativeEdit {...props} />
    </Template>
  )
}

const FicheComparativeEdit = (props: Props): JSX.Element => {
  const { t } = useTranslation()
  const { loading, data } = useQuery<
    FicheComparativeData,
    FicheComparativeVars
  >(FICHE_COMPARATIVE_SHOW, {
    variables: { id: props.ficheComparativeId },
  })

  const [ficheComparativeUpdate] = useMutation(FICHE_COMPARATIVE_UPDATE)

  if (loading) return <CentredLoader />

  const onSubmit = (values: any) => {
    ficheComparativeUpdate({
      variables: { id: props.ficheComparativeId, ...values },
    })
      .then(() =>
        openValidationPopup(
          t('ficheComparative.successTitle'),
          t('ficheComparative.update.successDescription')
        )
      )
      .catch(e => openErrorPopup(t('ficheComparative.errorTitle'), e.message))
  }

  return (
    <Wrapper>
      <FicheForm
        ficheComparative={data!.ficheComparative}
        onSubmit={onSubmit}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: #ffffff;
  display: block;
  width: 100%;
  padding: 15px;

  h4 {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 16px;
  }

  .page-content {
    background: white !important;
  }

  ${button}
`

export default Edit
